import { InventoryStockView } from "@medicorepay/ui";
import type { InventorySearchQuery } from "@medicorepay/shared";
import { productRevivalApi } from "@/services/product-revival-client";

const searchInventory = (query: InventorySearchQuery) =>
  productRevivalApi.searchInventory(query);

export function StockViewPage() {
  return <InventoryStockView searchInventory={searchInventory} />;
}
